import { Spacing } from '@persona-id/design-tokens';
import { CopyIcon, CutIcon, EditIcon, TrashIcon } from '@persona-id/design-tokens/icons';
import styled from 'styled-components';

import Button from 'design-system/components/Button';
import { HStack, HStackProps } from 'design-system/components/Stack';
import Tooltip from 'design-system/components/Tooltip';
import { Elevation } from 'design-system/variables/effect';

const ControlsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding-left: ${Spacing[1]};
  padding-right: ${Spacing[1]};
  height: ${Spacing[6]};
  background-color: ${({ theme }) => theme.color.background.primary};
  border-radius: ${({ theme }) => theme.element.borderRadius};
`;

export const ControlButtonGroup = styled(HStack).attrs<HStackProps>({
  spacing: Spacing[2],
})<HStackProps>``;

export const ControlButton = styled(Button).attrs(() => ({
  width: 'icon',
  variant: 'basic',
  type: 'button',
}))`
  width: ${Spacing[5]};
  height: ${Spacing[5]};
  box-shadow: ${Elevation.High};
  background-color: ${({ theme }) => theme.color.variants.basic.default};
  svg {
    color: ${({ theme }) => theme.color.primary.black};

    path {
      stroke: unset;
    }

    path[stroke] {
      stroke: currentColor;
    }
  }
`;
interface HoverEditControlsProps {
  hoverEditLink?: string;
  editable: boolean;
  handleEditClick?: () => void;
  handleDeleteClick?: () => void;
  handleCutClick?: () => void;
  handleCopyClick?: () => void;
}

const HoverEditControls = ({
  hoverEditLink,
  editable,
  handleEditClick,
  handleDeleteClick,
  handleCutClick,
  handleCopyClick,
}: HoverEditControlsProps) => {
  return (
    <ControlsContainer data-test='hover-controls__container'>
      <ControlButtonGroup equal>
        {/* the edit button functions more as a "nav to context to configure" button - consider renaming */}
        {/* display button in disabled state if custom tooltip label provided for explicit permissions handling */}
        {(hoverEditLink || handleEditClick) && (
          <Tooltip
            side='top'
            trigger={
              <ControlButton
                aria-label='Edit'
                id='hover-controls__edit-button'
                data-cy='hover-controls__edit-button'
                to={hoverEditLink}
                onClick={handleEditClick}
              >
                <EditIcon />
              </ControlButton>
            }
          >
            Edit
          </Tooltip>
        )}

        {editable && (
          <>
            {handleDeleteClick && (
              <Tooltip
                side='top'
                trigger={
                  <ControlButton
                    aria-label='Delete'
                    id='hover-controls__delete-button'
                    data-cy='hover-controls__delete-button'
                    onClick={handleDeleteClick}
                  >
                    <TrashIcon />
                  </ControlButton>
                }
              >
                Delete
              </Tooltip>
            )}

            {handleCutClick && (
              <Tooltip
                side='top'
                trigger={
                  <ControlButton
                    aria-label='Cut'
                    id='hover-controls__cut-button'
                    onClick={handleCutClick}
                  >
                    <CutIcon />
                  </ControlButton>
                }
              >
                Cut
              </Tooltip>
            )}

            {handleCopyClick && (
              <Tooltip
                side='top'
                trigger={
                  <ControlButton
                    aria-label='Copy'
                    id='hover-controls__copy-button'
                    data-cy='hover-controls__copy-button'
                    onClick={handleCopyClick}
                  >
                    <CopyIcon />
                  </ControlButton>
                }
              >
                Copy
              </Tooltip>
            )}
          </>
        )}
      </ControlButtonGroup>
    </ControlsContainer>
  );
};

export default HoverEditControls;
